export enum sharingProjectType {
    PUBLIC = 1,
    PUBLIC_LINK = 2,
    PRIVATE = 3
}